import { useState } from "react";
import { useConfig } from "./useConfig";
import { useSnackbar } from "notistack";

export interface IToken {
  email: string;
  dateExpiration: string; // ISO string for storage safety
}

export interface IUseToken {
  mockLogin: (email: string, password: string, rememberMe?: boolean) => boolean;
  loadToken: () => IToken | null;
  removeToken: () => void;
  isTokenExpired: () => boolean;
  loggedIn: boolean;
}

const HOURS_8 = 8 * 60 * 60 * 1000;

export function useFakeToken(): IUseToken {
  const { config } = useConfig();
  const { enqueueSnackbar } = useSnackbar();
  const getStorage = () => {
    const rememberMe = localStorage.getItem(rememberKey) === "true";
    return rememberMe ? localStorage : sessionStorage;
  };

  const isTokenExpired = (): boolean => {
    const token = loadToken();
    if (!token) return true;

    return new Date(token.dateExpiration).getTime() <= Date.now();
  };

  const loadToken = (): IToken | null => {
    const storage = getStorage();
    const raw = storage.getItem(storageKey);
    if (!raw) return null;

    try {
      return JSON.parse(raw) as IToken;
    } catch {
      return null;
    }
  };
  const storageKey = `${config.tokenPrefix}token`;
  const rememberKey = `${config.tokenPrefix}rememberMe`;
  const [loggedIn, setLoggedIn] = useState(() => !isTokenExpired());

  const mockLogin = (email: string, password: string, rememberMe = false) => {
    if (password !== "79nipio") {
      enqueueSnackbar(`Λάθος κωδικός ή email`, {
        variant: "error",
        autoHideDuration: 4000,
      });
      return false;
    }

    const expiration = new Date(Date.now() + HOURS_8);

    const token: IToken = {
      email,
      dateExpiration: expiration.toISOString(),
    };

    localStorage.setItem(rememberKey, String(rememberMe));
    const storage = rememberMe ? localStorage : sessionStorage;
    storage.setItem(storageKey, JSON.stringify(token));
    setLoggedIn(true);
    return true;
  };

  const removeToken = () => {
    localStorage.removeItem(storageKey);
    sessionStorage.removeItem(storageKey);
    localStorage.removeItem(rememberKey);
    setLoggedIn(false);
  };

  return {
    mockLogin,
    loadToken,
    removeToken,
    isTokenExpired,
    loggedIn,
  };
}
